import React, { useState, useEffect } from 'react';
import { Menu, Icon, Table, Button, Modal, Row, Col, Badge, Spin, Input, Form, Pagination } from 'antd';
import { browserHistory, Link } from 'react-router';
import _ from 'lodash';
import { get, orderBy } from 'lodash';
import cn from 'classnames';
import { formItemLayout } from 'constants/layout';
import { formatNumber } from 'utils/formatting';

import { connect } from 'react-redux';
import { getUserOrderItems } from 'data/order-item';
import { TableHelper } from 'helpers/Table';
// import { getUserOrders, getPageList, postNewPageContent } from 'redux/modules/content'
import moment from 'moment';
import Utils from 'utils/utils';

import classes from '../styles/student/StudentOrder.module.scss';

const SubMenu = Menu.SubMenu;
const MenuItemGroup = Menu.ItemGroup;
const FormItem = Form.Item;
const pageLimit = 10;

export default ({ user }) => {
  const [orderItems, setOrderItems] = useState([]);
  const [page, setPage] = useState(1);
  const [query, setQuery] = useState({ sortBy: '_id' });
  const [sortColumn, setSortColumn] = useState('createdAt');
  const [sortDirection, setSortDirection] = useState('desc');
  const [loading, setLoading] = useState(false);

  const onChangePage = (_page) => {
    getUserOrderItems(user._id, _.merge(getCurrentQuery(), { page }));
    setPage(_page);
  };

  const onReload = () => {
    getUserOrderItems(user._id, this.getCurrentQuery());
  };

  const fetchOrderItems = async (query) => {
    const _orderItems = await getUserOrderItems(user._id, query);
    setOrderItems(_orderItems.results);
  };
  useEffect(() => {
    if (user) {
      fetchOrderItems({});
    }
  }, [user]);

  const onTableChange = (a, b, sorter) => {
    const { field, order } = sorter;
    const _order = order === 'descend' ? 'desc' : 'asc';
    if (field === sortColumn) {
      setSortDirection(_order);
    } else {
      setSortColumn(field);
      setSortDirection(_order);
    }
  };

  const getCurrentQuery = () => {
    return {
      page: page,
      sortBy: query.sortBy,
    };
  };

  const columns = [
    {
      ...TableHelper.defaultColumn('Code', 'code'),
      render: (value, record) => (
        <div className="no-wrap">
          <Link to={`/order-item/${record._id}`}>{Utils.FormatNumberLength(value, 6)} </Link>
          {record.remark && <Icon type="pushpin" />}
        </div>
      ),
    },
    {
      ...TableHelper.defaultColumn('RefNo', 'orderRef'),
      render: (value, record) => (
        <div className="no-wrap">
          <Link to={`/order/${_.get(record, 'order._id')}`}>{_.get(record, 'order.refNo')} </Link>
          {/* {record.remark && <Icon type="pushpin" />} */}
        </div>
      ),
    },
    {
      ...TableHelper.datetimeColumn('Order\nDate &\n Time', 'createdAt'),
      sorter: true,
    },
    {
      ...TableHelper.defaultColumn('Class No.', 'class.classCode'),
      render: (value, record) => <Link to={`/class/${record.class._id}`}>{value}</Link>,
    },
    {
      ...TableHelper.defaultColumn('Class', 'class.name'),
      render: (value, record) => <Link to={`/class/${record.class._id}`}>{value}</Link>,
    },
    {
      ...TableHelper.defaultColumn('Teacher', 'teacher'),
      render: (value, record) => <Link to={`/teacher/${_.get(record, 'class.owner._id')}`}>{get(record.class, 'owner.displayName')}</Link>,
    },

    {
      ...TableHelper.defaultColumn('Status', 'status'),
      render: (value) => (
        <div>
          {value === 'pending' && <Badge status="default" text="Pending" />}
          {value === 'confirm' && <Badge status="warning" text="Confirmed" />}
          {value === 'paid' && <Badge status="processing" text="Paid" />}
          {value === 'success' && <Badge status="success" text="Success" />}
          {value === 'rejected' && <Badge status="error" text="Cancelled" />}
          {value === 'refunded' && <Badge status="warning" text="Refunded" />}
        </div>
      ),
      sorter: true,
    },
    {
      ...TableHelper.defaultColumn('Payment\nMethod', 'paymentMethod', true),
      // title: 'Payment method',
      // dataIndex: 'paymentMethod',
      render: (value) => <span>{value === 'cc' ? 'Credit card' : 'Bank Transfer'}</span>,
    },
    {
      ...TableHelper.datetimeColumn('Transfer Date', 'createdAt'),
      render: (value, record) => {
        const dateTime = _.get(record, 'order.paymentDetail.dateTime');
        return dateTime ? <span>{moment(dateTime).format('DD/MM/YYYY HH:mm')}</span> : <span />;
      },
      sorter: true,
    },
  ];

  const renderContentTable = () => {
    const sortedOrderItems = orderBy(orderItems, [sortColumn], [sortDirection]);

    const content = sortedOrderItems.map((singleContent, key) => {
      singleContent.key = key;
      return singleContent;
    });
    return (
      <div>
        <Table columns={columns} dataSource={content} bordered pagination={false} onChange={onTableChange} scroll={{ x: 1500 }} />
      </div>
    );
  };

  return (
    <div className="content">
      <Spin tip="Loading" size="large" spinning={!!loading}>
        {renderContentTable()}
      </Spin>
    </div>
  );
};

// export default connect(
//   (state) => ({
//   }),
//   {

//   },
// )(StudentOrder);
